/* eslint no-console: 0, no-unused-vars: 0, no-undef: "error" */
import Vue from 'vue'

export const store = {
  viewed: {
    signIn: false,
    recoverPassword: false,
    recoverPasswordSent: false,
    askForEmail: false,
    sendVerificationCode: false,
    enterVerificationCode: false,
    setPassword: false,
    selectLoanOfficer: false,
    multipleLoanOfficers: false,
    landingPage: false,
    registerAccount: false,
    termsAndConditions: false
  },
  authenticatedData: undefined,
  currentAuthState: undefined,
  authGuid: undefined,
  servicer: undefined,
  userEmailAddress: undefined,
  userPhoneNumber: undefined,
  userIsSignedIn: false,
  userHasRegisteredAccount: false,
  userHasSetPassword: false,
  userHasAcceptedTermsAndConditions: false,
  userHasMultipleLoanOfficers: false
}
